import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import DateTimeUtils from '@/lib/dateTimeUtils';

export default class CurrentBookingRoleStatisticsSearchCriteria {
    startAtFrom: string = DateTimeUtils.getThisMondayAsIso();
    selectedCompany: CompanyProfileDto;
    selectedLocation: LocationProfileDto;
    selectedDesk: DeskDto;
    selectedBranch: BranchDto;
}